export default ".box {\n  background: #f5f5f5;\n}\n.box .cta {\n  color: #000000;\n}"